<template>
  <div>
    <!-- <el-row>
            <el-col>
                <el-form size="small" :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="padding-top:0;margin-top:20px">
                    <el-form-item label="类型：">
                        <el-input  v-model="searchForm.CODE" clearable @keyup.enter.native="filtrate()"></el-input>
                    </el-form-item>
                    <el-button size="small" @click="filtrate()">筛选</el-button>
                </el-form>
            </el-col>
        </el-row> -->
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="showAddType()" style="margin-bottom:10px">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="400"></el-table-column>
          <el-table-column prop="TYPE_NAME" label="区域名称"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增仓库区域" center :visible.sync="addFormVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" size="small" :inline="true">
        <el-form-item label="仓库区域类型：" prop="lineInput">
          <el-input v-model="addForm.typename" placeholder="请输入区域名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="addType()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryWarehouseType, addWarehouseType } from '@/assets/api/warehouseManager';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10054',
      searchForm: {},
      customerLists: [],
      tableData: [],
      currentPage: 0,
      totalCount: 0,
      addForm: {},
      addFormVisible: false,
      formLabelWidth: '400px',
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryData();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    queryData(e) {
      queryWarehouseType()
        .then((res) => {
          if (res.length === 0) {
            this.tableData = [];
          }
          this.tableData = res;
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    handleChange(e) {
      this.currentPage = e - 1;
      this.queryData(e - 1);
    },
    addType() {
      const data = {
        TYPE_NAME: this.addForm.typename,
      };
      addWarehouseType(data)
        .then((res) => {
          this.$message.show({ text: '增加仓库类型成功', type: 'success' });
          this.queryData();
          this.addFormVisible = false;
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    showAddType() {
      this.addFormVisible = true;
      this.addForm = {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/warehouseArea.vue